<template>
    <ListadoEvento :event="event">
        <div class="actions d-flex justify-content-center justify-content-lg-end">
            <BotonesCompra :event="event" :productos="productos" @recargar="recargarEventos" />
        </div>
    </ListadoEvento>
</template>

<script>
    import ListadoEvento from '@/components/common/ListadoEvento'
    import BotonesCompra from '../botones/BotonesCompra';

    export default {
        props: {
            event: { 
                required: true, 
                type: Object 
            },
            productos: { 
                required: false, 
                default: false, 
                type: Boolean 
            }
        },
        methods: {
            recargarEventos() {
                const params = { 
                    filters : { 
                        tid : this.configuracion.hash_teatro 
                    } 
                }
                this.$store.dispatch(this.config.getVuexAlias('front.events.index'), params)
            }
        },
        computed: {
            configuracion() { 
                return this.$store.getters.getConfig; 
            }
        },
        components: {
            ListadoEvento, BotonesCompra
        }
    }
</script>